<template>
  <div style="padding-bottom: 50px">
    <div class="job-details">
      <!-- Row 1 Header Banner -->
      <div>
        <el-row :gutter="12" class="header bg-color">
          <!-- Role title & Company name -->
          <el-col :span="19" style="padding: 40px">
            <h3>
              {{ VacantRoleInfo.sgaEmployeeInfo.employeeRoleTitle }}
            </h3>
            <h6 style="color: #00c8dc; padding-top: 10px">
              {{ VacantRoleInfo.organisationName }}
            </h6>
          </el-col>
          <!-- Company logo -->
          <el-col :span="5" style="padding: 15px">
            <el-image
              v-if="VacantRoleInfo.logo"
              style="width: 130px; height: 130px"
              :src="VacantRoleInfo.logo"
              fit="fill"
            ></el-image>
          </el-col>
        </el-row>
      </div>

      <!-- Row 1.2 Company Branding -->
      <div
        style="padding-top: 40px"
        v-if="
          VacantRoleInfo.sgaAboutVacantRole != undefined &&
          VacantRoleInfo.sgaAboutVacantRole.branding != ''
        "
      >
        <el-row :gutter="12" class="header bg-color">
          <!-- Company Branding -->
          <el-col
            class="company-branding"
            style="padding: 10px"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
          >
            <div v-html="VacantRoleInfo.sgaAboutVacantRole.branding" />
          </el-col>
        </el-row>
      </div>

      <!-- Row 8 Company Branding -->
      <!-- <div style="padding-top: 40px;" v-if="VacantRoleInfo.SgaAboutVacantRole != undefined && VacantRoleInfo.SgaAboutVacantRole.Branding != ''">
                <el-row :gutter="12" class="header bg-color"> -->
      <!-- Company Branding -->
      <!-- <el-col :span="20" style="padding: 40px;">
                        <div v-html="VacantRoleInfo.SgaAboutVacantRole.Branding" />
                    </el-col>
                </el-row>
            </div> -->

      <!-- Row 2 Basic Informations -->
      <div style="padding-top: 40px">
        <el-row :gutter="12" class="header bg-color">
          <!-- Role details labels -->
          <el-col
            :span="12"
            style="
              padding-top: 40px;
              padding-left: 40px;
              padding-bottom: 40px;
              word-break: normal;
            "
          >
            <span class="padding-bot">
              <span class="lb-color"> Sector: </span>
              <span>{{ VacantRoleInfo.sectorName }}</span>
            </span>
            <br />
            <span class="padding-bot">
              <span class="lb-color"> Role Posted: </span>
              <span>{{
                new Date(VacantRoleInfo.submissionDate).toLocaleDateString(
                  "en-US",
                  options
                )
              }}</span>
            </span>
            <br />
            <span class="padding-bot">
              <span class="lb-color"> Deadline: </span>
              <span
                class="lb-color-disabled"
                v-if="
                  VacantRoleInfo.sgaEmployeeInfo.expirationDate ==
                  undefined
                "
                >- No expiry date -</span
              >
              <span v-else>
                {{
                  new Date(
                    VacantRoleInfo.sgaEmployeeInfo.expirationDate
                  ).toLocaleDateString("en-US", options)
                }}
              </span>
            </span>
            <br />
            <span class="padding-bot">
              <span class="lb-color"> Salary: </span>
              <span
                v-if="VacantRoleInfo.sgaEmployeeInfo.showRoleSalary"
              >
                {{ $t("cur-symbol") }}
                {{
                  formatPrice(
                    VacantRoleInfo.sgaEmployeeInfo.employeeSalary *
                      this.$ExchangeRates.data.filter(
                        (r) =>
                          r.Base ==
                          VacantRoleInfo.sgaEmployeeInfo.salaryCurrency
                      )[0].Rates[$t("currency")]
                  )
                }}
              </span>
              <span class="lb-color-disabled" v-else>- Confidential -</span>
            </span>
            <br />
            <span class="padding-bot">
              <span class="lb-color"> Role Type: </span>
              <span
                class="lb-color-disabled"
                v-if="
                  VacantRoleInfo.sgaEmployeeInfo.roleContract ==
                  undefined
                "
                >- No role type -</span
              >
              <span
                v-else-if="
                  VacantRoleInfo.sgaEmployeeInfo.roleContract ==
                  TypeOfRoleContract.FullTime
                "
              >
                FullTime
              </span>
              <span v-else>
                PartTime -
                {{ VacantRoleInfo.sgaEmployeeInfo.roleWorkingHours }}
                hours per week
              </span>
            </span>
            <br />
            <span class="padding-bot">
              <span class="lb-color"> Employment: </span>
              <span
                class="lb-color-disabled"
                v-if="
                  VacantRoleInfo.sgaEmployeeInfo.employmentType ==
                  undefined
                "
                >- No employment type -</span
              >
              <span
                v-else-if="
                  VacantRoleInfo.sgaEmployeeInfo.employmentType ==
                  TypeOfEmployment.Permanent
                "
              >
                Permanent
              </span>
              <span v-else>
                Temporary -
                {{ VacantRoleInfo.sgaEmployeeInfo.roleSpan }} months
              </span>
            </span>
            <br />
            <span class="padding-bot">
              <span class="lb-color"> Zip Code: </span>
              <span> {{ VacantRoleInfo.zipCode }} </span>
            </span>
            <br />
            <!-- <span class="padding-bot">
                            <span class="lb-color"> Location: </span>
                            <span class="padding-bot"> <el-button>View on Map</el-button>  </span>
                        </span> -->
          </el-col>

          <!-- Role tasks -->
          <el-col
            :span="12"
            style="padding-top: 40px; padding-right: 20px; padding-bottom: 40px"
          >
            <h6
              v-if="VacantRoleInfo.level"
              class="lb-color padding-bot"
            >
              Tasks You'll Be Doing
            </h6>
            <h6 v-else class="lb-color padding-bot">Tasks in the Role</h6>
            <div>
              <div
                class="with_border"
                style="word-break: normal;padding-bot"
                v-for="(task, index) in VacantRoleInfo.sgaYourJob
                  .jobDescriptionTasks"
                :key="index"
              >
                <v-icon class="check-circle" name="check-circle" />
                <span style="padding-left: 5px" class="padding-bot">
                  {{ task }}</span
                >
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- Row 3 About this Role -->
      <div style="padding-top: 40px">
        <el-row :gutter="12" class="header bg-color">
          <!-- About this Role Detail -->
          <el-col style="padding: 40px; word-break: normal">
            <h4 style="color: #00c8dc; padding-top: 10px; padding-bottom: 5px">
              About this Role
            </h4>
            <span
              class="padding-bot"
              v-if="
                VacantRoleInfo.sgaAboutVacantRole != undefined ||
                VacantRoleInfo.sgaAboutVacantRole.briefDescription != ''
              "
            >
              {{ VacantRoleInfo.sgaAboutVacantRole.briefDescription }}
            </span>
            <h5 v-else class="lb-color-disabled">
              - No Information about this Role -
            </h5>
          </el-col>
        </el-row>
      </div>

      <!-- Row 4 Skills Needed -->
      <div style="padding-top: 40px">
        <el-row :gutter="12" class="header bg-color">
          <el-col :span="10" style="padding-left: 40px; padding-top: 40px">
            <h5 v-if="VacantRoleInfo.level" style="color: #00c8dc">
              Skills You'll Learn
            </h5>
            <h5 v-else style="color: #00c8dc">Skills You'll Need</h5>
          </el-col>
        </el-row>
        <el-row :gutter="12" class="header bg-color">
          <!-- Skills -->
          <div style="padding: 40px; word-break: normal">
            <div
              v-for="(skill, index) in VacantRoleInfo.sgaSkills
                .workingPracticeSkills"
              :key="index"
            >
              <el-col :span="6" style="padding: 10px; height: 200px">
                <div class="with_border-colored" style="text-align: center">
                  <span style="font-weight: bold; color: black">{{
                    skill.selection
                  }}</span>
                  <br />
                  <span
                    v-if="VacantRoleInfo.level"
                    style="display: none"
                  ></span>
                  <span v-else
                    >{{ skill.yearsOfExperience }} years experience</span
                  >
                </div>
              </el-col>
            </div>
          </div>
        </el-row>
      </div>

      <!-- Row 5 Essential skills and Activities -->
      <div style="padding-top: 40px">
        <el-row :gutter="12" class="header bg-color">
          <!-- Essential Skills -->
          <el-col :span="12" style="padding: 40px; word-break: normal">
            <h5
              v-if="VacantRoleInfo.level"
              class="lb-color padding-bot"
            >
              Essential Skills You'll Acquire
            </h5>
            <h5 v-else class="lb-color padding-bot">
              Essential Skills for the Role
            </h5>
            <div>
              <div
                class="with_border"
                v-for="(mindset, index) in VacantRoleInfo.sgaMindset
                  .mindsets"
                :key="index"
              >
                <v-icon class="check-circle" name="check-circle" />
                <span style="padding-left: 5px"> {{ mindset.selection }}</span>
              </div>
            </div>
          </el-col>
          <!-- Activities -->
          <el-col
            :span="12"
            style="
              padding-top: 40px;
              padding-right: 20px;
              padding-bottom: 40px;
              word-break: normal;
            "
          >
            <h5
              v-if="VacantRoleInfo.Level"
              class="lb-color padding-bot"
            >
              Activities You'll Be Doing
            </h5>
            <h5 v-else class="lb-color padding-bot">Activities for the Role</h5>
            <div>
              <div
                class="with_border"
                v-for="(activity, index) in VacantRoleInfo
                  .sgaHiddenExtras.workingPracticeActivities"
                :key="index"
              >
                <v-icon class="check-circle" name="check-circle" />
                <span style="padding-left: 5px"> {{ activity.selection }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- Row 6 Knowledge Needed -->
      <div style="padding-top: 40px">
        <el-row :gutter="12" class="header bg-color">
          <el-col :span="10" style="padding-left: 40px; padding-top: 40px">
            <h5 v-if="VacantRoleInfo.level" style="color: #00c8dc">
              Knowledge You'll Learn
            </h5>
            <h5 v-else style="color: #00c8dc">Knowledge You'll Need</h5>
          </el-col>
        </el-row>
        <el-row :gutter="12" class="header bg-color">
          <!-- Knowledge -->
          <div style="padding: 40px; word-break: normal">
            <div
              v-for="(knowledge, index) in VacantRoleInfo.sgaKnowledge
                .knowledgeRegularlyUsed"
              :key="index"
            >
              <el-col :span="6" style="padding: 10px; height: 200px">
                <div class="with_border-colored" style="text-align: center">
                  <span style="font-weight: bold; color: black">{{
                    knowledge.selection
                  }}</span>
                  <br />
                  <span
                    v-if="VacantRoleInfo.level"
                    style="display: none"
                  ></span>
                  <span v-else
                    >{{ knowledge.yearsOfExperience }} years experience</span
                  >
                </div>
              </el-col>
            </div>
          </div>
        </el-row>
      </div>

      <!-- Row 7 Education and Certificates -->
      <div
        style="padding-top: 40px"
        v-if="
          VacantRoleInfo.sgaAboutVacantRole != undefined &&
          VacantRoleInfo.sgaCertifications != undefined
        "
      >
        <el-row :gutter="12" class="header bg-color">
          <!-- Education -->
          <el-col :span="12" style="padding: 40px">
            <h5 class="lb-color padding-bot">Education for the Role</h5>
            <div>
              <!-- Required -->
              <el-row :span="24">
                <span style="font-size: 14px">Required</span><br />
                <el-row :span="24">
                  <!-- Secondary Level Education -->
                  <el-col :span="12" style="padding-right: 5px">
                    <div
                      v-if="
                        VacantRoleInfo.sgaEducation
                          .secondLevelEducation != undefined
                      "
                    >
                      <span style="font-size: 14px; color: black"
                        >Secondary Level Education</span
                      >
                      <el-col :span="24">
                        <div
                          v-if="
                            VacantRoleInfo.sgaEducation
                              .secondLevelEducation.aLevelDetails != undefined
                          "
                          class="with_border-box"
                        >
                          <span
                            style="
                              font-size: 13px;
                              color: black;
                              text-align: center;
                            "
                            >A - Levels</span
                          >
                          <div
                            v-for="(alevel, index) in VacantRoleInfo
                              .sgaEducation.secondLevelEducation.aLevelDetails"
                            :key="index"
                          >
                            <span
                              v-if="alevel.required == true"
                              style="padding-left: 5px"
                            >
                              {{ alevel.grade }} - {{ alevel.subject }}</span
                            >
                          </div>
                        </div>
                        <div
                          v-if="
                            VacantRoleInfo.sgaEducation
                              .secondLevelEducation.oLevelDetails != undefined
                          "
                          class="with_border-box"
                        >
                          <span
                            style="
                              font-size: 13px;
                              color: black;
                              text-align: center;
                            "
                            >O - Levels</span
                          >
                          <div
                            v-for="(olevel, index) in VacantRoleInfo
                              .sgaEducation.secondLevelEducation.oLevelDetails"
                            :key="index"
                          >
                            <span
                              v-if="olevel.Required == true"
                              style="padding-left: 5px"
                            >
                              {{ olevel.grade }} - {{ olevel.subject }}</span
                            >
                          </div>
                        </div>
                      </el-col>
                    </div>
                  </el-col>

                  <!-- Third Level Education -->
                  <el-col :span="12" style="padding-left: 5px">
                    <div
                      v-if="
                        VacantRoleInfo.sgaEducation
                          .thirdLevelEducation != undefined
                      "
                    >
                      <span style="font-size: 14px; color: black"
                        >Third Level Education</span
                      >
                      <el-col :span="24">
                        <div
                          v-if="
                            VacantRoleInfo.sgaEducation
                              .thirdLevelEducation.associateDegreeDetails !=
                              undefined &&
                            VacantRoleInfo.sgaEducation
                              .thirdLevelEducation.associateDegreeDetails
                              .length != 0
                          "
                        >
                          <div
                            v-for="(adegree, index) in VacantRoleInfo
                              .sgaEducation.thirdLevelEducation
                              .associateDegreeDetails"
                            :key="index"
                          >
                            <div
                              v-if="adegree.required == false"
                              class="with_border-box"
                            >
                              <div>
                                <span
                                  style="
                                    font-size: 13px;
                                    color: black;
                                    text-align: center;
                                  "
                                  >Associate Degree</span
                                >
                              </div>
                              <span
                                v-if="adegree.required == true"
                                style="padding-left: 5px"
                              >
                                {{ adegree.courseTitle }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="
                            VacantRoleInfo.sgaEducation
                              .thirdLevelEducation.bachelorsDegreeDetails !=
                              undefined &&
                            VacantRoleInfo.sgaEducation
                              .thirdLevelEducation.bachelorsDegreeDetails
                              .length != 0
                          "
                        >
                          <div
                            v-for="(bdegree, index) in VacantRoleInfo
                              .sgaEducation.thirdLevelEducation
                              .bachelorsDegreeDetails"
                            :key="index"
                          >
                            <div
                              v-if="bdegree.required == true"
                              class="with_border-box"
                            >
                              <div>
                                <span
                                  style="
                                    font-size: 13px;
                                    color: black;
                                    text-align: center;
                                  "
                                  >Bachelors Degree</span
                                >
                              </div>
                              <span style="padding-left: 5px">
                                {{ bdegree.courseTitle }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </div>
                  </el-col>
                </el-row>

                <el-row :span="24">
                  <!-- Fourth Level Education -->
                  <el-col :span="12" style="padding-right: 5px">
                    <div
                      v-if="
                        VacantRoleInfo.sgaEducation
                          .fourthLevelEducation != undefined
                      "
                    >
                      <span style="font-size: 14px; color: black"
                        >Fourth Level Education</span
                      >
                      <el-col :span="24">
                        <div
                          v-if="
                            VacantRoleInfo.sgaEducation
                              .fourthLevelEducation.doctoralDegreeDetails !=
                              undefined &&
                            VacantRoleInfo.sgaEducation
                              .fourthLevelEducation.doctoralDegreeDetails
                              .length != 0
                          "
                        >
                          <div
                            v-for="(ddegree, index) in VacantRoleInfo
                              .sgaEducation.fourthLevelEducation
                              .doctoralDegreeDetails"
                            :key="index"
                          >
                            <div
                              v-if="ddegree.required == true"
                              class="with_border-box"
                            >
                              <div>
                                <span
                                  style="
                                    font-size: 13px;
                                    color: black;
                                    text-align: center;
                                  "
                                  >Doctoral Degree</span
                                >
                              </div>
                              <span style="padding-left: 5px">
                                {{ ddegree.courseTitle }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="
                            VacantRoleInfo.sgaEducation
                              .fourthLevelEducation.mastersDegreeDetails !=
                              undefined &&
                            VacantRoleInfo.sgaEducation
                              .fourthLevelEducation.mastersDegreeDetails
                              .length != 0
                          "
                        >
                          <div
                            v-for="(mdegree, index) in VacantRoleInfo
                              .sgaEducation.fourthLevelEducation
                              .mastersDegreeDetails"
                            :key="index"
                          >
                            <div
                              v-if="mdegree.required == true"
                              class="with_border-box"
                            >
                              <div>
                                <span
                                  style="
                                    font-size: 13px;
                                    color: black;
                                    text-align: center;
                                  "
                                  >Masters Degree</span
                                >
                              </div>
                              <span style="padding-left: 5px">
                                {{ mdegree.courseTitle }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </div>
                  </el-col>

                  <el-col :span="12" style="padding-left: 5px">
                    <!-- Sector Experience -->
                    <div
                      v-if="
                        VacantRoleInfo.sgaEducation.sectorExperience !=
                        undefined
                      "
                    >
                      <span style="font-size: 14px; color: black"
                        >Sector Experience</span
                      >
                      <el-col :span="24">
                        <div
                          v-for="(sector, index) in VacantRoleInfo
                            .sgaEducation.sectorExperience.experienceDetails"
                          :key="index"
                        >
                          <el-col :span="24" v-if="sector.required == true">
                            <div
                              class="with_border-box"
                              style="text-align: center"
                            >
                              <span style="font-size: 13px; color: black">{{
                                sector.title
                              }}</span>
                              <br />
                              <span>{{ sector.years }}</span>
                            </div>
                          </el-col>
                        </div>
                      </el-col>
                    </div>
                  </el-col>
                </el-row>
              </el-row>

              <!-- Desired -->
              <el-row :span="24">
                <span style="font-size: 14px">Desired</span><br />
                <el-row :span="24">
                  <!-- Secondary Level Education -->
                  <el-col :span="12" style="padding-right: 5px">
                    <div
                      v-if="
                        VacantRoleInfo.sgaEducation
                          .secondLevelEducation != undefined
                      "
                    >
                      <span style="font-size: 14px; color: black"
                        >Secondary Level Education</span
                      >
                      <el-col :span="24">
                        <div
                          v-if="
                            VacantRoleInfo.sgaEducation
                              .secondLevelEducation.aLevelDetails != undefined
                          "
                          class="with_border-box"
                        >
                          <span
                            style="
                              font-size: 13px;
                              color: black;
                              text-align: center;
                            "
                            >A - Levels</span
                          >
                          <div
                            v-for="(alevel, index) in VacantRoleInfo
                              .sgaEducation.secondLevelEducation.aLevelDetails"
                            :key="index"
                          >
                            <span
                              v-if="alevel.Required == false"
                              style="padding-left: 5px"
                            >
                              {{ alevel.grade }} - {{ alevel.subject }}</span
                            >
                          </div>
                        </div>
                        <div
                          v-if="
                            VacantRoleInfo.sgaEducation
                              .secondLevelEducation.oLevelDetails != undefined
                          "
                          class="with_border-box"
                        >
                          <span
                            style="
                              font-size: 13px;
                              color: black;
                              text-align: center;
                            "
                            >O - Levels</span
                          >
                          <div
                            v-for="(olevel, index) in VacantRoleInfo
                              .sgaEducation.secondLevelEducation.oLevelDetails"
                            :key="index"
                          >
                            <span
                              v-if="olevel.required == false"
                              style="padding-left: 5px"
                            >
                              {{ olevel.grade }} - {{ olevel.subject }}</span
                            >
                          </div>
                        </div>
                      </el-col>
                    </div>
                  </el-col>

                  <!-- Third Level Education -->
                  <el-col :span="12" style="padding-left: 5px">
                    <div
                      v-if="
                        VacantRoleInfo.sgaEducation
                          .thirdLevelEducation != undefined
                      "
                    >
                      <span style="font-size: 14px; color: black"
                        >Third Level Education</span
                      >
                      <el-col :span="24">
                        <div
                          v-if="
                            VacantRoleInfo.sgaEducation
                              .thirdLevelEducation.associateDegreeDetails !=
                              undefined &&
                            VacantRoleInfo.sgaEducation
                              .thirdLevelEducation.associateDegreeDetails
                              .length != 0
                          "
                        >
                          <div
                            v-for="(adegree, index) in VacantRoleInfo
                              .sgaEducation.thirdLevelEducation
                              .associateDegreeDetails"
                            :key="index"
                          >
                            <div
                              v-if="adegree.required == false"
                              class="with_border-box"
                            >
                              <div>
                                <span
                                  style="
                                    font-size: 13px;
                                    color: black;
                                    text-align: center;
                                  "
                                  >Associate Degree</span
                                >
                              </div>
                              <span
                                v-if="adegree.required == false"
                                style="padding-left: 5px"
                              >
                                {{ adegree.courseTitle }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="
                            VacantRoleInfo.sgaEducation
                              .thirdLevelEducation.bachelorsDegreeDetails !=
                              undefined &&
                            VacantRoleInfo.sgaEducation
                              .thirdLevelEducation.bachelorsDegreeDetails
                              .length != 0
                          "
                        >
                          <div
                            v-for="(bdegree, index) in VacantRoleInfo
                              .sgaEducation.thirdLevelEducation
                              .bachelorsDegreeDetails"
                            :key="index"
                          >
                            <div
                              v-if="bdegree.required == false"
                              class="with_border-box"
                            >
                              <div>
                                <span
                                  style="
                                    font-size: 13px;
                                    color: black;
                                    text-align: center;
                                  "
                                  >Bachelors Degree</span
                                >
                              </div>
                              <span style="padding-left: 5px">
                                {{ bdegree.courseTitle }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </div>
                  </el-col>
                </el-row>

                <el-row :span="24">
                  <!-- Fourth Level Education -->
                  <el-col :span="12" style="padding-right: 5px">
                    <div
                      v-if="
                        VacantRoleInfo.sgaEducation
                          .fourthLevelEducation != undefined
                      "
                    >
                      <span style="font-size: 14px; color: black"
                        >Fourth Level Education</span
                      >
                      <el-col :span="24">
                        <div
                          v-if="
                            VacantRoleInfo.sgaEducation
                              .fourthLevelEducation.doctoralDegreeDetails !=
                              undefined &&
                            VacantRoleInfo.sgaEducation
                              .fourthLevelEducation.doctoralDegreeDetails
                              .length != 0
                          "
                        >
                          <div
                            v-for="(ddegree, index) in VacantRoleInfo
                              .sgaEducation.fourthLevelEducation
                              .doctoralDegreeDetails"
                            :key="index"
                          >
                            <div
                              v-if="ddegree.required == false"
                              class="with_border-box"
                            >
                              <div>
                                <span
                                  style="
                                    font-size: 13px;
                                    color: black;
                                    text-align: center;
                                  "
                                  >Doctoral Degree</span
                                >
                              </div>
                              <span style="padding-left: 5px">
                                {{ ddegree.courseTitle }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="
                            VacantRoleInfo.sgaEducation
                              .fourthLevelEducation.mastersDegreeDetails !=
                              undefined &&
                            VacantRoleInfo.sgaEducation
                              .fourthLevelEducation.mastersDegreeDetails
                              .length != 0
                          "
                        >
                          <div
                            v-for="(mdegree, index) in VacantRoleInfo
                              .sgaEducation.fourthLevelEducation
                              .mastersDegreeDetails"
                            :key="index"
                          >
                            <div
                              v-if="mdegree.required == false"
                              class="with_border-box"
                            >
                              <div>
                                <span
                                  style="
                                    font-size: 13px;
                                    color: black;
                                    text-align: center;
                                  "
                                  >Masters Degree</span
                                >
                              </div>
                              <span style="padding-left: 5px">
                                {{ mdegree.courseTitle }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </div>
                  </el-col>

                  <el-col :span="12" style="padding-left: 5px">
                    <!-- Sector Experience -->
                    <div
                      v-if="
                        VacantRoleInfo.sgaEducation.sectorExperience !=
                        undefined
                      "
                    >
                      <span style="font-size: 14px; color: black"
                        >Sector Experience</span
                      >
                      <el-col :span="24">
                        <div
                          v-for="(sector, index) in VacantRoleInfo
                            .sgaEducation.sectorExperience.experienceDetails"
                          :key="index"
                        >
                          <el-col :span="24" v-if="sector.required == false">
                            <div
                              class="with_border-box"
                              style="text-align: center"
                            >
                              <span style="font-size: 13px; color: black">{{
                                sector.Title
                              }}</span>
                              <br />
                              <span>{{ sector.years }}</span>
                            </div>
                          </el-col>
                        </div>
                      </el-col>
                    </div>
                  </el-col>
                </el-row>
              </el-row>
            </div>
          </el-col>
          <!-- Certificates -->
          <el-col
            :span="12"
            style="
              padding-top: 40px;
              padding-right: 20px;
              padding-bottom: 40px;
              word-break: normal;
            "
          >
            <h5 class="lb-color padding-bot">Certificates for the Role</h5>
            <div
              v-if="
                VacantRoleInfo.sgaCertifications != undefined &&
                VacantRoleInfo.sgaCertifications.userCertifications
                  .length != 0
              "
            >
              <span style="font-size: 14px">Required</span>
              <div
                v-for="(certificate, index) in VacantRoleInfo
                  .sgaCertifications.userCertifications"
                :key="index"
              >
                <div v-if="certificate.required == true" class="with_border">
                  <span
                    v-if="certificate.description"
                    style="padding-left: 5px"
                  >
                    {{ certificate.Description }}</span
                  >
                  <span v-else style="padding-left: 5px">
                    {{ certificate.codeDetailDesc }}</span
                  >
                </div>
              </div>
              <span style="font-size: 14px">Desired</span>
              <div
                v-for="(certificate, index) in VacantRoleInfo
                  .sgaCertifications.userCertifications"
                :key="index"
              >
                <div v-if="certificate.Required == false" class="with_border">
                  <span
                    v-if="certificate.description"
                    style="padding-left: 5px"
                  >
                    {{ certificate.description }}</span
                  >
                  <span v-else style="padding-left: 5px">
                    {{ certificate.codeDetailDesc }}</span
                  >
                </div>
              </div>
            </div>
            <div v-else>
              <h6 class="lb-color-disabled">
                - No Information about this certificates -
              </h6>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- Row 8 Company Branding -->
      <!-- <div style="padding-top: 40px;" v-if="VacantRoleInfo.SgaAboutVacantRole != undefined && VacantRoleInfo.SgaAboutVacantRole.Branding != ''">
                <el-row :gutter="12" class="header bg-color"> -->
      <!-- Company Branding -->
      <!-- <el-col :span="20" style="padding: 40px;">
                        <div v-html="VacantRoleInfo.SgaAboutVacantRole.Branding" />
                    </el-col>
                </el-row>
            </div> -->
    </div>
  </div>
</template>

<script>
import { TypeOfEmployment, TypeOfRoleContract } from "@/enums";

import DisplayItem from "../../components/workflow/DisplayItem.vue";

export default {
  props: {
    VacantRoleInfo: Object,
    ShowComponent: Boolean,
  },
  components: {
    DisplayItem,
  },
  mounted: function () {
    this.$nextTick(function () {
      var jobDetailsPrint =
        document.getElementsByClassName("job-details-print")[0];
      var companyBranding =
        jobDetailsPrint.getElementsByClassName("company-branding")[0];
      companyBranding.style.overflow = "hidden";

      var images = companyBranding.querySelectorAll("img");
      var xdata = images[0].parentElement.parentElement.getAttributeNames()[0];
      images.forEach((e) => {
        e.setAttribute(xdata, "");
        if (e.width > 500) {
          e.style.width = "100%";
        }
      });

      this.selectedCurrency =
        this.$i18n.messages[localStorage.getItem("locale")].currency;
    });
  },
  destroyed: function () {
    var jobDetailsPrint =
      document.getElementsByClassName("job-details-print")[0];
    var companyBranding =
      jobDetailsPrint.getElementsByClassName("company-branding")[0];
    companyBranding.style.overflow = "";
    var images = companyBranding.querySelectorAll("");
    images.forEach((e) => {
      e.classList.remove("print-image");
    });
  },
  methods: {
    formatPrice(value) {
      const val = (value / 1).toFixed(0).replace(",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    convert(val) {
      if (val != undefined) {
        if (val.includes("youtube.com")) {
          var id = val.split("https://www.youtube.com/watch?v=");
          return "https://www.youtube.com/embed/" + id[1];
        } else if (val.includes("vimeo.com")) {
          var id = val.split("https://vimeo.com/");
          return "https://player.vimeo.com/video/" + id[1];
        } else if (val == "" || val == null) {
          return "";
        } else {
          return val;
        }
      }
    },
  },
  data() {
    return {
      TypeOfEmployment,
      TypeOfRoleContract,
      options: { year: "numeric", month: "long", day: "numeric" },
      salaryCurrency: null,
      convertedSalary: null,
      selectedCurrency: null,
    };
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #f7fafc !important;
}

.lb-color {
  color: #00c8dc !important;
}

.lb-color-disabled {
  color: #aeaeae !important;
}

.padding-bot {
  font-size: 16px !important;
  padding-bottom: 25px !important;
}

.with_border {
  border: 1px solid #f3f3f3 !important;
  border-radius: 6px !important;
  background-color: white !important;
  font-size: 17px !important;
  padding: 10px !important;
  margin: 0 0 10px 0 !important;
}

.with_border-box {
  border: 1px solid #f3f3f3 !important;
  border-radius: 6px !important;
  background-color: white !important;
  font-size: 15px !important;
  padding: 10px !important;
  margin: 0 0 10px 0 !important;
}

.with_border-colored {
  border: 1px solid #00c8dc !important;
  border-radius: 6px !important;
  background-color: #e5f9fb !important;
  font-size: 17px !important;
  padding: 10px !important;
  margin: 0 0 10px 0 !important;
}

.check-circle {
  color: green !important;
}

@media print {
  img {
    display: block;
    margin: auto;
    visibility: visible;
  }
}
</style>
